import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export const Label = ({ className, screenReaderOnly, font, color, hasErrors, children, ...rest }) => {
    return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _jsxs("label", { className: classNames("eds-label", {
            [`eds-color--${color}`]: color,
            [`eds-type--${font}`]: font,
            "eds-hidden--screen-reader-only": screenReaderOnly,
        }, className), ...rest, children: [children, hasErrors && (_jsxs(_Fragment, { children: [_jsx("span", { className: "eds-color--text-danger", "aria-hidden": true, children: "*" }), _jsx("span", { className: "eds-hidden--screen-reader-only", children: " Error" })] }))] }));
};
